import { useState, useEffect, useRef } from "react";
import axios from 'axios';
import { Alert } from "../alert/Alert.component";
import { Secondary } from "../secondary/Secondary.component";
import { Menu } from "../menu/Menu.component";
import { Static } from "../static/Static.component";
import { Mobile } from "../mobile/Mobile.component";
import { Hero } from "../hero/Hero.component";

import { StyledDiv } from "./Header.styles";
import Bg from './families-and-friends-header.a69e92c1.jpg'

export const Header = ({apiUrl}) => {
    const [apiData, setApiData] = useState(null);
    const contentRef = useRef();
    const skipToContentAnchorTag = useRef();
    // Get the header data from the public website
    useEffect(() => {
        axios.get(apiUrl)
            .then(res => {
                setApiData(res.data[0])
            });
    },[apiUrl]);

    // Skip to Content
    const handleFocusOfSkipToContentAnchor = () => {
        if (skipToContentAnchorTag.current) {
            skipToContentAnchorTag.current.className = "skip-to-content-visible";
        }
    };
    const handleBlurOfSkipToContentAnchor = () => {
        if (skipToContentAnchorTag.current) {
            skipToContentAnchorTag.current.className = "skip-to-content-invisible";
        }
    };
    const handleSkipToContent = (e) => {
        e.preventDefault();
        if (contentRef.current) {
            contentRef.current.focus();
        }
    };

    if (apiData) {
        return (
        <>
            <a
            href="#"
            onClick={handleSkipToContent}
            ref={skipToContentAnchorTag}
            className="skip-to-content-invisible"
            onFocus={handleFocusOfSkipToContentAnchor}
            onBlur={handleBlurOfSkipToContentAnchor}
        >
            Skip to Content
        </a>
            <Alert show={apiData.Alert[0].hasSiteAlert} msg={apiData.Alert[0].siteMessage} />
            <header>
                <Mobile menuData={apiData.Mobile} secondaryData={apiData.SecondaryMenu} searchData={apiData.SearchUrl} />
                <StyledDiv background={Bg} id="hero-banner">
                    <Secondary linksData={apiData.SecondaryMenu} searchData={apiData.SearchUrl} />
                    <Menu menuData={apiData.Menu} />
                    <Hero />
                </StyledDiv>
            </header>
          <div ref={contentRef} tabIndex="-1" style={{width:"100%", textIndent:"-1000px", overflow:"hidden"}}>Content</div>
        </>
    );
    } else {
        return <Static />;
    }
    
}